import { HeDaoTaoService } from "../services/hedaotao.service";

var state = {
	hedaotaos: []
};

var getters = {};

var mutations = {
	getHeDaoTaos(state, data) {
		state.hedaotaos = [...data];
	},
};

var actions = {
	getHeDaoTaos({ commit }) {
		return HeDaoTaoService.getHeDaoTaos()
			.then(async (response) => {
				if (response.status === 200)
					await commit("getHeDaoTaos", response.data);
				return response;
			})
			.catch((error) => error.message);
	},

};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
